module.exports = __webpack_public_path__ + "img/20200414-1.29903070.png";